import _ from 'lodash';
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import SimpleHeader from '../../../../components/layout/SimpleHeader';
import Split from "react-split";
import Button from "../../../../components/Button";
import useAuth from "../../../../hooks/useAuth";
import { Table, TableColumnsType } from "antd";
import { ITreeSubcode, IAddTreeSubCodeReq, ITreeSubCodeReq, ITreeCodeSeqReq } from "../../../../models/treeCodes.model";
import TreeCodeEditModal from "../../../../components/system/treeCode/modals/TreeCodeEditModal";
import { doCreateTreeSubcode, doGetTreeSubcodes, doUpdateSubcodeSeq, doUpdateTreeSubcode } from "../../../../store/treeCode.slice";
import { useDispatch } from "react-redux";
import { errorVariant, infoVariant, successVariant, warningVariant } from '../../../../lib/barVariant';
import { useSnackbar } from "notistack";
import { doRemoveAuth } from '../../../../store/auth.slice';
import { useHistory, useRouteMatch } from "react-router-dom";

interface IMatch {
  id: string;
}

const SystemTreeCodeSubCode = () => {
  const { t, i18n } = useTranslation();
  const { writeAuthYn } = useAuth();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const match = useRouteMatch<IMatch>();
  const selectedCommonCode = String(match.params.id);

  const [codeData1, setCodeData1] = useState<ITreeSubcode[]>([]);
  const [codeData2, setCodeData2] = useState<ITreeSubcode[]>([]);
  const [codeData3, setCodeData3] = useState<ITreeSubcode[]>([]);
  const [codeEditVisible, setCodeEditVisible] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [actionTreeLevel, setActionTreeLevel] = useState(0);
  const [selectedCodeData, setSelectedCodeData] = useState<ITreeSubcode>();
  const [selectedFirstCodeInfo, setSelectedFirstCodeInfo] = useState<ITreeSubcode>();
  const [selectedSecondCodeInfo, setSelectedSecondCodeInfo] = useState<ITreeSubcode>();

  useEffect(() => {
    //init Codes (parentDetailCode, treeLevel)
    getTreeCodes(0, 1);
  }, []);

  const getCodeDataStateByLevel = (treeLevel: number) => {
    if(treeLevel === 1) {
      return codeData1;
    } else if(treeLevel === 2) {
      return codeData2;
    } else if(treeLevel === 3) {
      return codeData3;
    } else {
      return [];
    }
  }

  const getCodeDataFnByLevel = (treeLevel: number) => {
    if(treeLevel === 1) {
      return setCodeData1;
    } else if(treeLevel === 2) {
      return setCodeData2;
    } else if(treeLevel === 3) {
      return setCodeData3;
    }
  }

  const getCodeDataLengthByLevel = (treeLevel: number) => {
    if(treeLevel === 1) {
      return codeData1.length;
    } else if(treeLevel === 2) {
      return codeData2.length;
    } else if(treeLevel === 3) {
      return codeData3.length;
    }
  }

  const getTreeCodes = async (parentDetailCode: number, treeLevel: number) => {
    const param : ITreeSubCodeReq = {commonCode:selectedCommonCode, parentDetailCode:parentDetailCode, treeLevel:treeLevel} 
    const res = await dispatch(doGetTreeSubcodes(selectedCommonCode, param));

    switch (res?.status) {
      case 200:
        const codeDataFn = getCodeDataFnByLevel(treeLevel);
        if(codeDataFn) {
          codeDataFn(res?.data?.data);
        }
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      case 404:
        enqueueSnackbar(t('common.message.notFound'), warningVariant);
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  };

  const onCreate = async (data: IAddTreeSubCodeReq) => {        

    data.commonCode = selectedCommonCode;

    //submit
    const res = await dispatch(doCreateTreeSubcode(selectedCommonCode, data));
      
    switch (res?.status) {
      case 200:
        enqueueSnackbar(t('common.message.create'), successVariant);

        getTreeCodes(data.parentDetailCode, data.treeLevel);
        setCodeEditVisible(false);
        break;
      case 400:
        enqueueSnackbar(t('system.code.message1'), infoVariant);
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        // eslint-disable-next-line no-restricted-globals
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const onUpdate = async (data: IAddTreeSubCodeReq) => {

    const commonCode = data.commonCode;
    
    //submit
    const res = await dispatch(doUpdateTreeSubcode(commonCode, data.detailCode, data));
    switch (res?.status) {
      case 200:
        enqueueSnackbar(t('common.message.create'), successVariant);
        
        getTreeCodes(data.parentDetailCode, data.treeLevel);
        setCodeEditVisible(false);
        break;
      case 400:
        enqueueSnackbar(t('system.code.message1'), infoVariant);
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      case 500:
        if(res?.data?.data === 'DUP_ERROR') {
          enqueueSnackbar(t('system.treecode.msg1'), errorVariant);
        } else {
          enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
        }
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const sortCode = (menus: ITreeSubcode[]) => menus.sort((a, b) => a.orderSeq < b.orderSeq ? -1 : (a.orderSeq > b.orderSeq ? 1 : 0));

  const raiseCode = (orderSeq: number, treeLevel: number) => {
    const _code = _.cloneDeep(getCodeDataStateByLevel(treeLevel));
    const index = _code.findIndex(code => code.orderSeq === orderSeq);
    _code[index].orderSeq--;
    _code[index - 1].orderSeq++;
    const codeDataFn = getCodeDataFnByLevel(treeLevel);
    if(codeDataFn) {
      codeDataFn(sortCode(_code));
    }
  }

  const lowerCode = (orderSeq: number, treeLevel: number) => {
    const _code = _.cloneDeep(getCodeDataStateByLevel(treeLevel));
    const index = _code.findIndex(code => code.orderSeq === orderSeq);
    _code[index].orderSeq++;
    _code[index + 1].orderSeq--;
    const codeDataFn = getCodeDataFnByLevel(treeLevel);
    if(codeDataFn) {
      codeDataFn(sortCode(_code));
    }
  }

  const saveSequence = async (treeLevel: number) => {
    const seqData: ITreeCodeSeqReq[] = [];
    const _code = getCodeDataStateByLevel(treeLevel);

    _code.forEach(code => {
      seqData.push({
        detailCode: code.detailCode,
        orderSeq: code.orderSeq
      })
    })

    const res = await dispatch(doUpdateSubcodeSeq(selectedCommonCode, seqData));

    switch (res?.status) {
      case 200:
        enqueueSnackbar(t('common.message.save'), successVariant);

        let parentDetailCode = 0;
        if(treeLevel === 2) {
          if(selectedFirstCodeInfo) {
            parentDetailCode = selectedFirstCodeInfo.detailCode;
          }
        } else if(treeLevel === 3) {
          if(selectedSecondCodeInfo) {
            parentDetailCode = selectedSecondCodeInfo.detailCode;
          }
        }

        getTreeCodes(parentDetailCode, treeLevel);
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }
      
  const columns: TableColumnsType<ITreeSubcode> = [
    {
      title: t('system.code.column1'),
      dataIndex: 'treeId',
      key: 'treeId',
      width: 80,
      /* sorter: (a, b) => a.treeId?.localeCompare(b.treeId) */
    },
    {
      title: t('system.treecode.column1'),
      dataIndex: 'korName',
      key: 'korName',
      /* sorter: (a, b) => a.korName?.localeCompare(b.korName), */
      render: (value, record) => i18n.language === 'ko' ? value : record.engName,
    },
    {
      title: t('system.menu.column4'),
      dataIndex: 'orderSeq',
      key: 'orderSeq',
      render: (value: number, record) => (
        <div className="order-sett__area">
          <a
            className={value === 1 ? 'btn-order up disabled' : 'btn-order up'}
            onClick={() => {
              if (value === 1) return;
              raiseCode(value, record.treeLevel);
            }}
          />
          <a
            className={value === getCodeDataLengthByLevel(record.treeLevel) ? 'btn-order down disabled' : 'btn-order down'}
            onClick={() => {
              if (value === getCodeDataLengthByLevel(record.treeLevel)) return;
              lowerCode(value, record.treeLevel);
            }}
          />
        </div>
      ),
    },
    {
      title: '',
      key: 'detailCode',
      dataIndex: 'detailCode',
      render: (detailCode: string, record) => (
        <div className='comm-btn__area justify-content-center'>
          <Button
            className='btn-basic small pink-line'
            onClick={() => {
                setIsEdit(true);
                setActionTreeLevel(record.treeLevel);
                setSelectedCodeData(record);
                setCodeEditVisible(true)
            }}
            text={t('common.button.edit')}
            writeAuthYn={writeAuthYn}
          />
        </div>
      ),
    }
  ];

  return(
  <>
    <SimpleHeader
        iconFile="icon-system-big.svg"
        parentMenu={t('common.menu.system')}
        currentMenu={'트리코드 관리'}
        onlyTitle={true}
    />
    <div className="content">
      <Split
        className="splite-divide"
        sizes={[34, 33, 33]}
        minSize={100}
        expandToMin={false}
        gutterSize={10}
        gutterAlign="center"
        snapOffset={30}
        dragInterval={1}
        direction="horizontal"
        cursor="col-resize"
      >
        {/* first side */}
        <div className="col-frame">
          <div className="comm-bx__between">
              <h3 className="sub-title">{t('system.treecode.account1')}</h3>
              <div className="comm-btn__area right">
                  <Button
                  className='btn-basic pink'
                  onClick={() => {
                    setIsEdit(false);
                    setActionTreeLevel(1);
                    setCodeEditVisible(true);
                  }}
                  text={t('common.button.create')}
                  writeAuthYn={writeAuthYn}
                  />
              </div>
          </div>
            
          <div className='comm-table__area'>
            <Table
              columns={columns}
              dataSource={codeData1}
              pagination={{
                pageSize: 99999,
              }}
              rowKey={(record)=>record.detailCode}
              rowClassName="pointer"
              onRow={(record) => {
                return {
                  onClick: () => {
                    setSelectedFirstCodeInfo(record);
                    getTreeCodes(record.detailCode, 2);
                    if(record.detailCode !== selectedFirstCodeInfo?.detailCode) {
                      setCodeData3([]);
                    }
                  },
                };
              }}
            />
          </div>
          <div className="comm-bx__space">
            <div className="comm-btn__area right">
              <Button
                className='btn-basic pink'
                onClick={() => {
                  saveSequence(1);
                }}
                text={t('system.menu.button2')}
                writeAuthYn={writeAuthYn}
              />
            </div>
          </div>
        </div>

        {/* second side */}
        <div className="col-frame">
          <div className="comm-bx__between">
            <h3 className="sub-title">{t('system.treecode.account2')}</h3>
            {
              (selectedFirstCodeInfo) &&
              <div className="comm-btn__area right">
                <Button
                  className='btn-basic pink'
                  onClick={() => {
                    setIsEdit(false);
                    setActionTreeLevel(2);
                    setCodeEditVisible(true)
                  }}
                  text={t('common.button.create')}
                  writeAuthYn={writeAuthYn}
                />
              </div>
            }
          </div>
          <div className='comm-table__area'>
            <Table
              columns={columns}
              dataSource={codeData2}
              pagination={{
                pageSize: 99999,
              }}
              rowKey={(record)=>record.detailCode}
              rowClassName="pointer"
              onRow={(record) => {
                return {
                  onClick: () => {
                    setSelectedSecondCodeInfo(record);
                    getTreeCodes(record.detailCode, 3);
                  },
                };
              }}
            />
          </div>
          {
            (selectedFirstCodeInfo) &&
            <div className="comm-bx__space">
              <div className="comm-btn__area right">
                <Button
                  className='btn-basic pink'
                  onClick={() => {
                    saveSequence(2);
                  }}
                  text={t('system.menu.button2')}
                  writeAuthYn={writeAuthYn}
                />
              </div>
            </div>
          }
        </div>

        {/* third side */}
        <div className="col-frame">
          <div className="comm-bx__between">
              <h3 className="sub-title">{t('system.treecode.account3')}</h3>
              {
                (selectedSecondCodeInfo) &&
                <div className="comm-btn__area right">
                  <Button
                    className='btn-basic pink'
                    onClick={() => {
                      setIsEdit(false);
                      setActionTreeLevel(3);
                      setCodeEditVisible(true)
                    }}
                    text={t('common.button.create')}
                    writeAuthYn={writeAuthYn}
                  />
                </div>
              }
          </div>
          <div className='comm-table__area'>
            <Table
              columns={columns}
              dataSource={codeData3}
              pagination={{
                pageSize: 99999,
              }}
              rowKey={(record)=>record.detailCode}
              rowClassName="pointer"
            />
          </div>
          {
            (selectedSecondCodeInfo) &&
            <div className="comm-bx__space">
              <div className="comm-btn__area right">
                <Button
                  className='btn-basic pink'
                  onClick={() => {
                    saveSequence(2);
                  }}
                  text={t('system.menu.button2')}
                  writeAuthYn={writeAuthYn}
                />
              </div>
            </div>
          }
        </div>
      </Split>
    </div>

    { codeEditVisible && (
    <TreeCodeEditModal
      visible={codeEditVisible}
      setVisible={setCodeEditVisible}
      isEdit={isEdit}
      actionTreeLevel={actionTreeLevel}
      selSubCodeData={selectedCodeData}
      selFirstCodeData={selectedFirstCodeInfo}
      selSecondCodeData={selectedSecondCodeInfo}
      onCreate={onCreate}
      onUpdate={onUpdate}
    />
    )}
  </>
  );
}

export default SystemTreeCodeSubCode;